var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 153.68 68.95",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "titleId"
  }, "Your Title Here") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "titleId"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.47,68.58H76.22c-7.62-.11-37-2.92-51.12-8.41C7.83,53.55,2.34,46.27,1,44.25A83.1,83.1,0,0,0,7.16,31.36c1.91-4.94,4.37-17.83,8-20.86S40.35.64,76.45.64H77.9c36.21,0,57.74,6.84,61.33,9.86s6.05,16,8,20.86a97.94,97.94,0,0,0,6.16,12.89c-1.34,2.13-6.95,9.3-24.1,15.92-14.13,5.38-43.5,8.3-51.12,8.41H74.88",
    transform: "translate(-0.4 -0.14)",
    fill: "#fff",
    stroke: "#404041",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27,31.24c1.91-4.93,4.38-17.82,8-20.85C16.58,9.27,18.15,33,68.82,33c1.12,0,7.51.11,7.51,4.37V68.58c-7.62-.11-37-2.92-51.12-8.41C8,53.55,2.45,46.27,1.11,44.25A88.45,88.45,0,0,0,7.27,31.24Z",
    transform: "translate(-0.4 -0.14)",
    fill: "#fff",
    stroke: "#404041",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.41,31.24c-1.9-4.93-4.37-17.82-8-20.85C138.11,9.27,136.54,33,85.86,33c-1.12,0-7.51.11-7.51,4.37V68.58c7.62-.11,37-2.92,51.12-8.41,17.27-6.62,22.76-13.9,24.11-15.92A128.22,128.22,0,0,1,147.41,31.24Z",
    transform: "translate(-0.4 -0.14)",
    fill: "#fff",
    stroke: "#404041",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.79,25.75h-.67c-16.82,0-32.63.11-45.07.79C39.9,30.24,51.44,33,68.93,33c1.13,0,7.52.11,7.52,4.37V68.47h.33c.34,0,.9-.12,1.8-.12V37.41C78.58,33.15,85,33,86.09,33c17.49,0,29-2.8,36.88-6.5C110.41,26,94.5,25.75,77.79,25.75Z",
    transform: "translate(-0.4 -0.14)",
    fill: "#404041",
    style: {
      isolation: "isolate"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBand);
export default __webpack_public_path__ + "static/media/band.55208e3e541f1ec76f301dcbedb972c1.svg";
export { ForwardRef as ReactComponent };